import MottoAlignersRFV from '@/assets/SVG/MottoAlignersRFV';

import { reasonForVisitStyles } from './ReasonForVisit.styles';

export const MottoAligners = () => (
	<div
		style={
			{
				...reasonForVisitStyles.reasonForVisitIcon,
				...reasonForVisitStyles.reasonForVisitIconMotto,
			} as React.CSSProperties
		}
	>
		<MottoAlignersRFV />
	</div>
);
